export const SUCCESS_ENUM = 'passed';
export const FAILED_ENUM = 'failed';
export const IN_PROCESS_ENUM = 'running';
export const QUEUED_ENUM = 'queued';
export const CANCELED_ENUM = 'canceled';
